module.exports = __webpack_public_path__ + "static/Lorenzo-Sinigaglia-635931b77344b7b62be4b986ab6fc270.jpg";